import React, { useContext, useEffect, useState } from "react";
import CodingGroupsDataGrid from "components/shared/CodingGroupComponents/CodingGroupsDataGrid";
import FiltersComponent from "components/shared/CodingGroupComponents/FiltersComponent";
import TopPanelComponent from "components/shared/CodingGroupComponents/TopPanelComponent";
import { Box, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import api from "api";
import { useNavigate } from "react-router-dom";
import { UserContext } from "context";
import CustomGridToolbar from "components/GridToolbar";

const DiagnosisGroups = () => {
  const user = useContext(UserContext);
  const [rowData, setRowData] = useState([]);
  const navigate = useNavigate();
  const canEditOrCreate =
    user?.groups?.includes("POET-Avalon-Admin") ||
    (user?.groups?.includes("POET-Avalon-POE") &&
      (user?.POETSkill?.includes("Coding") ||
        user?.POETSkill?.includes("Manager")));

  const getDiagnosisCodeGroups = async () => {
    const response = await api.diagnosisCode.getCodeGroupDiagnosisCodeList();
    // Avoid mutating the response; create a derived array
    return (response?.data ?? []).map((item) => ({
      ...item,
      ...(item.codeGroupVersion !== undefined && {
        codeGroupVersion: Number(item.codeGroupVersion).toFixed(1),
      }),
    }));
  };

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const data = await getDiagnosisCodeGroups();
        if (!cancelled) setRowData(data);
      } catch (error) {
        console.error("Error fetching diagnosis code groups:", error);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  const CustomToolbar = () => {
    return (
      <GridToolbarContainer
        sx={{
          "& .MuiDataGrid-toolbar, & .MuiDataGrid-toolbarContainer": {
            borderBottom: "none",
          },
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          p={1}
          width="100%"
        >
          {canEditOrCreate ? (
            <Link
              component={RouterLink}
              to="/coding-group-editor"
              state={{ page: "Diagnosis Groups" }}
              underline="always"
              sx={{ fontWeight: "bold" }}
            >
              Create Diagnosis Group
            </Link>
          ) : (
            <Box
              sx={{
                fontWeight: "bold",
                color: "text.disabled",
                cursor: "not-allowed",
                alignItems: "center",
                textDecoration: "underline",
                opacity: 0.6,
              }}
            >
              Create Diagnosis Group
            </Box>
          )}

          <Box sx={{ width: "40%", alignItems: "center", height: "auto" }}>
            <CustomGridToolbar
              quickFilterParser={(searchInput) =>
                searchInput.split(",").map((value) => value.trim())
              }
            />
          </Box>
        </Box>
      </GridToolbarContainer>
    );
  };
  const handleRowClick = (params) => {
    // Handle row click event
    navigate(`/coding-group-editor/${params.row.codeGroupKey}`, {
      state: { page: "Diagnosis Groups" },
    });
  };
  return (
    <div>
      <TopPanelComponent page="Diagnosis Groups" />
      <FiltersComponent />
      <CodingGroupsDataGrid
        rowData={rowData}
        CustomToolbar={CustomToolbar}
        getRowId={(row) => row.codeGroupKey}
        onRowClick={handleRowClick}
      />
    </div>
  );
};

export default DiagnosisGroups;
